var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.05 2.5H10.95C6.25005 2.5 5.88755 6.725 8.42505 9.025L21.575 20.975C24.1125 23.275 23.75 27.5 19.05 27.5H10.95C6.25005 27.5 5.88755 23.275 8.42505 20.975L21.575 9.025C24.1125 6.725 23.75 2.5 19.05 2.5Z",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.ac7a956f.svg";
export { ForwardRef as ReactComponent };